import ChannelFilters from './ChannelFilters.view';

export default ChannelFilters;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Channels/ChannelFilters/index.js